module.exports = __webpack_public_path__ + "static/img/Crackers.e641600.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Stamp Assests/Crackers.svg
// module id = LBDw
// module chunks = 1